var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('visual',{staticClass:"image_title",attrs:{"id":_vm.id,"image":_vm.simage,"background":"cover","load":"visible"}},[_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }